import React from 'react';

const RefreshIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
    <g fill="none" fillRule="evenodd">
      <g fill="#BEBEBE">
        <path d="M8.19 0v7.897l4.29-3.948zM8.19 2.945v2.058c-2.434.116-4.18 1.081-5.236 2.894-1.055 1.814-1.055 3.778 0 5.893l-1.496 1.754c-1.799-3.599-1.799-6.654 0-9.167C3.257 3.865 5.501 2.721 8.19 2.945z" />
      </g>
      <path
        fill="#BEBEBE"
        d="M8.081 22v-7.897L3.792 18.05zM8.081 19.055v-2.058c2.435-.116 4.18-1.081 5.236-2.894 1.056-1.814 1.056-3.778 0-5.893l1.496-1.754c1.8 3.599 1.8 6.654 0 9.167-1.798 2.512-4.042 3.656-6.732 3.432z"
      />
    </g>
  </svg>
);

export default RefreshIcon;
